const noConsecutiveSpaces = (value?: string) => {
  return value
    ? value.replace(/[ ]{2,}/gi, ' ').replace(/\n +/, '\n')
    : value;
};

export default noConsecutiveSpaces;
